import { AuthService } from './auth.service';

export const authAppInitializerFactory =
  (authService: AuthService): (() => Promise<void>) =>
  () => {
    return authService.runInitialLoginSequence();
  };
